import domainVertical from '../api/domains'
import {cloneObjectArray} from "@/helpers";

export default {
  state: {
    verticalGroup: [],
    verticalGroupOrigin: [],
    domainGroup: [],
    domainGroupOrigin: [],
    domainHistory: [],
    domainItems: [],
  },
  namespaced: true,
  mutations: {
    async saveVerticalGroup(state, verticalGroup) {
      let count = 1
      verticalGroup.forEach(item=>{
        item.id = count
        count++
      })
      state.verticalGroup = verticalGroup
      state.verticalGroupOrigin = cloneObjectArray(verticalGroup)
    },
    async saveDomainGroup(state, domainGroup) {
      state.domainGroup = domainGroup
      state.domainGroupOrigin = cloneObjectArray(domainGroup)
    },
    async saveDomainItems(state, domainItems) {
      state.domainItems = domainItems
    },
    updDomainGroup(state, item) {
      let isBudgetValueNotChange= false
      state.domainGroup.forEach(domain=>{
        if (domain.id === item.id && domain.budget === Number(item.budget)){
          isBudgetValueNotChange=true
        }
      })
      if (isBudgetValueNotChange) return

      state.domainGroupOrigin.forEach(domain=>{
        if (domain.id === item.id ){
          item.oldBudgetValue = domain.budget
        }
      })
      if (state.domainHistory.filter(history=>(history.id===item.id)).length === 0){
        state.domainHistory.push({
          id: item.id,
          domainName: item.domainName,
          budget: Number(item.budget),
          oldBudgetValue: item.oldBudgetValue
        })
      } else {
        state.domainHistory.forEach(history=>{
          if (history.id === item.id){
            history.budget = Number(item.budget)
          }
        })
      }

      state.domainGroup.forEach(domain=>{
        if (domain.id === item.id){
          domain.budget = Number(item.budget)
        }
      })
    },
    rollbackChangesDomains(state){
      state.domainGroup = cloneObjectArray(state.domainGroupOrigin)
      // state.domainHistory = []
    },
    commitChangesDomains(state){
      state.domainHistory = []
    },
    updDomainItemsStatus(state, data){
      const {offersIds, status} = data

      state.domainItems.forEach(item=>{
        const check = offersIds.filter(i=>(i.id === item.offerId))
        if (check.length !==0 ){
          item.offerStatus = status
        }
      })
    }
  },
  actions: {
    async saveVerticalGroupStore({commit}, payload) {
      commit('saveVerticalGroup', await domainVertical.verticalGroup(payload))
    },
    async saveDomainGroupStore({commit}, payload) {
      commit('saveDomainGroup', await domainVertical.domainGroup(payload))
    },
    async saveDomainItemsStore({commit}, id) {
      const domainVerticalItems = await domainVertical.domainVerticalItems()
      const domainVerticalItemsByDomain = domainVerticalItems.filter(i=>(i.domainVerticalId === Number(id)))
      commit('saveDomainItems', domainVerticalItemsByDomain)
    },
    async updateDomainsBudget({commit}, data) {
      return await domainVertical.updateDomainsBudget(data)
    },
    async updateOfferStatus({commit}, data) {
      return await domainVertical.updateOfferStatus(data)
    },
  },
  getters: {
    getVerticalGroup: state => state.verticalGroup,
    getDomainGroup: state => state.domainGroup,
    getDomainGroupOrigin: state => state.domainGroupOrigin,
    getDomainItems: state => state.domainItems,
    getDomainHistory: state => state.domainHistory,
  },
}
